import { render, staticRenderFns } from "./EventLevelAdd.vue?vue&type=template&id=48a6b1f3"
import script from "./EventLevelAdd.vue?vue&type=script&lang=js"
export * from "./EventLevelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports